<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <input-field
          label="File path"
          label-position="top"
          name="filePath"
        >
          <div
            v-clipboard:copy="filePath"
            v-clipboard:success="copySuccess"
            class="text-primary cursor-pointer"
            style="line-break: anywhere;"
          >
            {{ filePath || '-' }}
            <GjIcon
              name="Copy"
              size="20"
            />
          </div>
        </input-field>
      </b-col>
      <b-col
        cols="12"
        sm="6"
      >
        <input-field
          label="Destination"
          label-position="top"
          name="Destination"
        >
          <div
            class="text-primary cursor-pointer"
            style="line-break: anywhere;"
            @click="openStorage"
          >
            {{ destination || '-' }}
          </div>
        </input-field>
      </b-col>
    </b-row>
    <b-row v-if="callbackUrl">
      <b-col>
        <input-field
          label="Callback URL"
          label-position="top"
          :info="{
            title: 'Callback Response JSON',
            content: callbackResponse,
          }"
          info-position="label"
          name="callbackUrl"
          @openInfo="viewJson"
        >
          <div>
            {{ callbackUrl || '-' }}
          </div>
        </input-field>
      </b-col>
    </b-row>
    <json-preview v-model="jsonToPreview" />
  </div>
</template>

<script>
import InputField from '@/components/form/InputField.vue'
import JsonPreview from '@/components/info/JsonPreview.vue'
import { callbackResponse } from '../code'
import helpers from '@/mixins/helpers'

export default {
  name: 'InputSummary',
  components: {
    InputField,
    JsonPreview,
  },
  mixins: [helpers],
  props: {
    destination: {
      type: String,
      default: '',
    },
    filePath: {
      type: String,
      default: '',
    },
    callbackUrl: {
      type: String,
      default: null,
    },
    s3AccountId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      callbackResponse,
      jsonToPreview: null,
    }
  },
  methods: {
    viewJson(a) {
      this.jsonToPreview = a
    },
    openStorage() {
      if (this.destination) {
        const temp = this.destination.split('/')
        const bucket = temp[0]
        const key = `${temp.slice(1, temp.length).join('/')}/`
        this.$router.push({
          name: 'object-files',
          params: {
            projectId: this.$route.params.projectId,
            accountId: this.s3AccountId > 0 ? this.s3AccountId : this.$store.state.externalAccount.accountId,
            id: bucket,
          },
          query: {
            key,
          },
        })
      }
    },
  },
}
</script>

<style></style>
